import React, { useState, CSSProperties } from "react";
import { Form } from "react-bootstrap";

export interface DropDownControlProps {
    dropDownOptions: (DropDownOption)[];
    id?: string;
    name: string;
    onChange?: any;
    onBlur?: any;
    defaultValue?: string;
    className?: string;
    disabled?: boolean;
    displayWithValue?: boolean;
    style?: CSSProperties;
    tabIndex?: number;
}

export interface DropDownOption {
    display: string;
    value: string;
}

const DropDown = (props: DropDownControlProps) => {

    const [ddlValue, setDDlValue] = useState(props.defaultValue);

    const onChangeInternal = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDDlValue(e.target.value);
        if (props.onChange) {
            props.onChange(e);
        }
    }

    const options = props.dropDownOptions != null && props.dropDownOptions.length > 0 && props.dropDownOptions.map((ddlOption, i) => (
        <option key={i} value={ddlOption.value}>
            {props.displayWithValue ? ddlOption.display + " (" + ddlOption.value + ")" : ddlOption.display}
        </option>) 
    );

    return (
        <Form.Control
            as="select"
            style={props.style}
            id={props.id}
            name={props.name}
            value={ddlValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { onChangeInternal(e) }}          
            className={props.className}
            disabled={props.disabled}
            tabIndex={props.tabIndex}
        >
            {options}
        </Form.Control>
    )
};

export { DropDown };